import { BagPaymentListTableColumn } from '@/bag/bag-payment-list/bag-payment-list.model';
import { ChangeDetectionStrategy, Component, computed, input, LOCALE_ID } from '@angular/core';

const DEFAULT_LEGACY_COLUMNS: BagPaymentListTableColumn[] = [
	{ id: 'amount', name: 'Suma kwoty' },
	{ id: 'currency', name: 'Waluta' },
];

const API_SUMMARY_COLUMNS: BagPaymentListTableColumn[] = [{ id: 'amount', name: 'Suma kwoty' }];

@Component({
	selector: 'app-bag-payment-list-table-summary',
	templateUrl: './bag-payment-list-table-summary.component.html',
	styleUrls: ['./bag-payment-list-table-summary.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{ provide: LOCALE_ID, useValue: 'pl-PL' }],
})
export class BagPaymentListTableSummaryComponent {
	readonly totalAmount = input(0);
	readonly data = input<{ amount: string | number; currency: string }[]>();
	readonly tableColumns = input<BagPaymentListTableColumn[]>();

	readonly isLegacyMode = computed(() => this.data() !== undefined);

	readonly columns = computed(() => {
		if (this.isLegacyMode()) {
			return this.tableColumns() ?? DEFAULT_LEGACY_COLUMNS;
		}

		return API_SUMMARY_COLUMNS;
	});

	readonly tableKeys = computed(() => this.columns().map((column) => column.id));

	readonly tableData = computed(() => {
		if (this.isLegacyMode()) {
			return this.data() ?? [{ amount: '0', currency: '-' }];
		}

		return [{ amount: this.totalAmount() }];
	});
}
